var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForum = function SvgForum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 40,
    viewBox: "210 0 540 540"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.543 270v0c0-131.696 106.761-238.457 238.457-238.457v0C622.749 33.453 716.602 146.987 718.457 270v0c0 131.696-106.761 238.457-238.457 238.457v0c-131.696 0-238.457-106.761-238.457-238.457Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M636.72 268.418a156.017 156.02 0 0 1-155.816 156.02 156.017 156.02 0 0 1-156.216-155.62A156.017 156.02 0 0 1 480.105 112.4 156.017 156.02 0 0 1 636.72 267.62l-156.015.798z",
    style: {
      opacity: 1,
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "currentColor",
      strokeWidth: 2.96074,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.186 366.102h80.085v50.339h-80.085z",
    style: {
      opacity: 1,
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "currentColor",
      strokeWidth: 2.40001,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.61 270.338a21.625 21.627 0 0 1-21.597 21.627 21.625 21.627 0 0 1-21.652-21.572 21.625 21.627 0 0 1 21.542-21.682 21.625 21.627 0 0 1 21.707 21.516l-21.624.11z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 1.74616,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.34 270.59a21.625 21.627 0 0 1-21.597 21.627 21.625 21.627 0 0 1-21.653-21.572 21.625 21.627 0 0 1 21.542-21.682 21.625 21.627 0 0 1 21.708 21.516l-21.625.11zM583.996 271.572a21.625 21.627 0 0 1-21.597 21.627 21.625 21.627 0 0 1-21.653-21.572 21.625 21.627 0 0 1 21.542-21.682 21.625 21.627 0 0 1 21.708 21.516l-21.625.11z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 1.74616,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgForum;